var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 23,
    height: 32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.99,21.25V4.18c0-1.93-1.56-3.49-3.49-3.49s-3.49,1.56-3.49,3.49v17.07c-1.23,1.01-2.01,2.54-2.01,4.25,0,3.04,2.46,5.5,5.5,5.5s5.5-2.46,5.5-5.5c0-1.71-.78-3.24-2.01-4.25Zm-3.49,8.28c-2.22,0-4.03-1.81-4.03-4.03,0-1.21.54-2.35,1.48-3.12l.54-.44V4.18c0-1.12.91-2.02,2.02-2.02s2.02.91,2.02,2.02v17.77l.54.44c.94.77,1.48,1.91,1.48,3.12,0,2.22-1.81,4.03-4.03,4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.57,22.78v-13.89c0-.59-.48-1.07-1.07-1.07h0c-.59,0-1.07.48-1.07,1.07v13.89c-1.09.43-1.85,1.48-1.85,2.72,0,1.61,1.31,2.92,2.92,2.92s2.92-1.31,2.92-2.92c0-1.24-.77-2.29-1.85-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.88,19.68h-2.78c-.34,0-.61-.27-.61-.61s.27-.61.61-.61h2.78c.34,0,.61.27.61.61s-.27.61-.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.9,16.13h-1.8c-.34,0-.61-.27-.61-.61s.27-.61.61-.61h1.8c.34,0,.61.27.61.61s-.27.61-.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.88,12.59h-2.78c-.34,0-.61-.27-.61-.61s.27-.61.61-.61h2.78c.34,0,.61.27.61.61s-.27.61-.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.9,9.04h-1.8c-.34,0-.61-.27-.61-.61s.27-.61.61-.61h1.8c.34,0,.61.27.61.61s-.27.61-.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.88,5.5h-2.78c-.34,0-.61-.27-.61-.61s.27-.61.61-.61h2.78c.34,0,.61.27.61.61s-.27.61-.61.61Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/temp.20b1bb950127d3d8a575f7be6352da42.svg";
export { ForwardRef as ReactComponent };